import { ToolBase } from "./_helpers";
/** The logic for the DC Power calculator */
export class LedResistorCalculator extends ToolBase {
    constructor() {
        super("tools-resistor-calculator");
    }
    onLoad() {
        this.sVoltsBox = this.loadNumberBox('input-source-volts');
        this.fVoltsBox = this.loadNumberBox('input-forward-volts');
        this.currentBox = this.loadNumberBox('input-forward-current');
    }
    onSubmit() {
        if (!this.checkAllBoxesAreFilled(this.sVoltsBox, this.currentBox, this.sVoltsBox))
            return;
        let sv = +this.sVoltsBox.value;
        let fv = +this.fVoltsBox.value;
        let fc = +this.currentBox.value;
        let r = ((sv - fv) / fc) * 1000;
        let commonValues = [10, 12, 15, 18, 22, 27, 33, 39, 47, 56, 68, 82, 100, 120, 150, 180, 220, 270, 330, 390, 470, 560, 680, 820, 1000, 1200, 1500, 1800, 2200, 2700, 3300, 3900, 4700, 5600, 6800, 8200, 10000, 12000, 15000, 18000, 22000, 27000, 33000, 39000, 47000, 56000, 68000, 82000, 100000, 120000, 150000, 180000, 220000, 270000, 330000, 390000, 470000, 560000, 680000, 820000];
        var arrayIndex = this.getNextHighestIndex(commonValues, r);
        var resistorValue = this.numberFormatter(commonValues[arrayIndex], 3);
        this.showResult({ result: resistorValue + " Ω", pre: "The resistor value you need is:", post: `The actual resistance is ${this.numberFormatter(r, 1)} Ω but we have rounded up to to the nearest common resistor` });
    }
    onClear() {
        this.sVoltsBox.value = "";
        this.currentBox.value = "";
        this.fVoltsBox.value = "";
        document.getElementById("calculator-result").innerHTML = "";
        document.getElementById("calculator-result-container").style.display = "none";
    }
    getNextHighestIndex(arr, value) {
        var i = arr.length;
        while (arr[--i] > value)
            ;
        return ++i;
    }
    numberFormatter(num, digits) {
        var si = [
            { value: 1E18, symbol: "E" },
            { value: 1E15, symbol: "P" },
            { value: 1E12, symbol: "T" },
            { value: 1E9, symbol: "G" },
            { value: 1E6, symbol: "M" },
            { value: 1E3, symbol: "k" }
        ], rx = /\.0+$|(\.[0-9]*[1-9])0+$/, i;
        for (i = 0; i < si.length; i++) {
            if (num >= si[i].value) {
                return (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
            }
        }
        return num.toFixed(digits).replace(rx, "$1");
    }
}
;
